
import { tipoImovelSiglasLegado } from "constants/tiposImovelLegado"
import { MapTipoImovelToEnumLegado } from "services/CalcTaxaFunctionsLegado"

export function MapInputsToTaxBody(nameServ, input)
{

    let body = {}

    /* eslint no-fallthrough: ["off", { "allowEmptyCase": true }] */

    switch (nameServ)
    {
        case "Alvara": case "Anuencia":
        {
            body["edif"] = { "areaConstruida": Number(input.areaConstruida), "tipo": input.tipoImovel, "caracteristicas": input.caracteristicas }
            if (input.tipoImovel === tipoImovelSiglasLegado["Uniresidencial"])
            {
                body["conjuntoHabitacional"] = input.conjuntoHabitacional
            }
            if (input.tipoImovel === tipoImovelSiglasLegado["Multiresidencial até 4 pavimentos"] | input.tipoImovel === tipoImovelSiglasLegado["Multiresidencial acima de 4 pavimentos"])
            {
                body["multiRes"] = {"areaUtil": input.areaUtil}
            }
            if (input.tipoImovel === tipoImovelSiglasLegado["Condomínio de lotes"] | input.tipoImovel === tipoImovelSiglasLegado["Condomínio de lotes comercial"])
            {
                body["condLotes"] = {"areaTerreno": input.areaTerreno, "temComercio": input.temComercio}
            }
            if (input.tipoImovel === tipoImovelSiglasLegado["ERB"])
            {
                body["erb"] = {"numEstacoes": input.numEstacoes}
            }
            if (input.tipoImovel === tipoImovelSiglasLegado["GLP"])
            {
                body["glp"] = {"areaPlataforma": input.areaPlataforma}
            }
            body["loteamento"] = {"areaTerreno": input.areaTerreno}
            body["taxaOcupMenor30"] = input.taxaOcupMenor30
            body["anuencia"] = input.anuencia
            body["valorAnuencia"] = input.valorAnuencia
            body["houveInicioDeObra"] = input.houveInicioDeObra
            body["valorPagoInicioDeObra"] = input.valorPagoInicioDeObra
            body["obraEmExecucao"] = input.obraEmExecucao === "Sim" ? true : false
            
            return body
        }
        case "AlvaraAcresReg":
        {
            body["edif"] = {"areaConstruida": Number(input.areaConstruida), "tipo": input.tipoImovel, "caracteristicas": input.caracteristicas}
            body["multiRes"] = {"areaUtil": input.areaUtil}
            body["condLotes"] = {"areaTerreno": input.areaTerreno, "temComercio": input.temComercio}
            body["glp"] = {"areaPlataforma": input.areaPlataforma}
            body["taxaOcupMenor30"] = input.taxaOcupMenor30
            body["anuencia"] = input.anuencia
            body["valorAnuencia"] = input.valorAnuencia
            body["areaAcrescidaMaisReforma"] = Number(input.areaAcrescida) + Number(input.areaReforma)
            body["areaAverbada"] = input.areaAverbada
            body["areaRegularizar"] = input.areaRegularizar
            body["areaNovoUso"] = input.areaNovoUso
            body["qualUso"] = input.usoAreaAverbada
            body["executadaComLicenca"] = input.executadaComLicenca
            body["houveInicioDeObra"] = input.houveInicioDeObra
            body["valorPagoInicioDeObra"] = input.valorPagoInicioDeObra
            body["obraEmExecucao"] = input.obraEmExecucao === "Sim" ? true : false
            if (input.tipoImovel === tipoImovelSiglasLegado["Uniresidencial"])
            {
                body["conjuntoHabitacional"] = input.conjuntoHabitacional
            }
            return body
        }
        case "AutObrasInfra": case "CertRegulInfra":
        {
            body["valorContrato"] = input.valorContrato
            body["houveInicioDeObra"] = input.houveInicioDeObra

            return body
        }
        case "AutERB": case "DeclConcInstERBComAut":
        {
            body["numEstacoes"] = input.numEstacoes

            return body
        }
        case "AutoDeInfracao":
        {
            body["diasAposVencimento"] = input.diasAposVencimento
        }
        case "AutRepGerais":
        case "AutRepGeraisAcess":
        {
            body["houveInicioDeObra"] = input.houveInicioDeObra

            return body
        }
        case "CertRegul":
        {
            body["vistoria"] =
            {
                "tipoImovelVist": input.tipoImovelVist,
                "numUnid": input.numUnid,
                "edif": { "areaConstruida": Number(input.areaConstruida),
                            "tipo": input.tipoImovel, "caracteristicas": input.caracteristicas }
            }
            body["infosBasicaEdif"] =
            {
            "multiRes": {"areaUtil": input.areaUtil},
                    "condLotes": {"areaTerreno": input.areaTerreno, "temComercio": input.temComercio},
                    "glp": {"areaPlataforma": input.areaPlataforma},
                    "erb": {"numEstacoes": input.numEstacoes},
                "edif": { "areaConstruida": Number(input.areaConstruida),
                            "tipo": input.tipoImovel, "caracteristicas": input.caracteristicas },
                "loteamento": {"areaTerreno": input.areaTerreno, "numUnid": input.numUnid}
            }
            body["temNovoUso"] = false
            const temAreaAverbada = document.getElementsByName("usoAreaAverbada")[0] !== undefined
            if (temAreaAverbada)
            {
                const novoUso = document.getElementsByName("usoAreaAverbada")[0].value
                body["temNovoUso"] = (document.getElementsByName("tipoImovel")[0].value !== document.getElementsByName("usoAreaAverbada")[0].value)
                body["novoUso"] = MapTipoImovelToEnumLegado(novoUso, input.temComercio)
            }
            body["areaAverbadaComMudancaDeUso"] = input.areaAverbadaComMudancaDeUso
            body["tipoCondominio"] = input.tipoCondominio

            body["areaAverbada"] = input.areaAverbadaOuAprovada
            body["areaRegularizar"] = input.areaRegularizar
            body["executadaComLicenca"] = input.executadaComLicenca
            body["atendeAsNormasUrb"] = input.atendeAsNormasUrb
            body["taxaOcupMenor30"] = input.taxaOcupMenor30
            if (input.tipoImovel === tipoImovelSiglasLegado["Uniresidencial"])
            {
                body["conjuntoHabitacional"] = input.conjuntoHabitacional
            }

            return body
        }
        case "DeclConcInstERBSemAut":
        {
            body["numEstacoes"] = input.numEstacoes
            body["atendeAsNormasUrb"] = input.atendeAsNormasUrb

            return body
        }
        case "ObraIniciadaSemLicenca" :
        {
            body["edif"] = {"areaConstruida": Number(input.areaConstruida), "tipo": input.tipoImovel, "caracteristicas": input.caracteristicas}
            if (input.tipoImovel === tipoImovelSiglasLegado["Multiresidencial até 4 pavimentos"] | input.tipoImovel === tipoImovelSiglasLegado["Multiresidencial acima de 4 pavimentos"])
            {
                body["multiRes"] = {"areaUtil": input.areaUtil}
            }
            if (input.tipoImovel === tipoImovelSiglasLegado["Condomínio de lotes"] | input.tipoImovel === tipoImovelSiglasLegado["Condomínio de lotes comercial"])
            {
                body["condLotes"] = {"areaTerreno": input.areaTerreno, "temComercio": input.temComercio}
            }
            if (input.tipoImovel === tipoImovelSiglasLegado["ERB"])
            {
                body["erb"] = {"numEstacoes": input.numEstacoes}
            }
            if (input.tipoImovel === tipoImovelSiglasLegado["GLP"])
            {
                body["glp"] = {"areaPlataforma": input.areaPlataforma}
            }
            body["loteamento"] = {"areaTerreno": input.areaTerreno}
            body["obraEmExecucao"] = input.obraEmExecucao === "Sim" ? true : false
            body["areaAcrescida"] = input.areaAcrescida

            return body
        }
        case "TermoDemarc":
        {
            body["testada"] = input.testada
            body["incluirTaxaDemarcacao"] = input.incluirTaxaDemarcacao

            return body
        }
        case "CertHabitese": case "RenHabitese":
        {
            body["edif"] = { "areaConstruida": Number(input.areaConstruida), "tipo": input.tipoImovel, "caracteristicas": input.caracteristicas }
            body["numUnid"] = Number(input.numUnid)
            body["tipoCond"] = input.tipoCondominio

            return body
        }
        case "DeclGLP":
        {
            body["areaPlataforma"] = input.areaPlataforma

            return body
        }
        case "TermoDesm": case "TermoRem": case "TermoDesmRem": case "TermoDesmComIncorporacao":
        {
            body["areaTerreno"] = input.areaTerreno
            body["areaRemanescente"] = input.areaRemanescente
            body["possuiDemarcacao"] = input.possuiDemarcacao
            body["testada"] = input.testada

            return body
        }
        case "TermoVerObras":
        {
            body["numUnid"] = input.numUnid

            return body
        }
        case "TermoPermUsoEspacoPublico":
        {
            body["numVagas"] = Number(input.numVagas)

            return body
        }
        case "RenAlvara":
        {
            body["valorAlvara"] = input.valorAlvara
        }
        case "SubsProj":
        {
            body["edif"] = { "areaConstruida": Number(input.areaConstruida), "tipo": input.tipoImovel, "caracteristicas": input.caracteristicas }
            if (input.tipoImovel === tipoImovelSiglasLegado["Multiresidencial até 4 pavimentos"] | input.tipoImovel === tipoImovelSiglasLegado["Multiresidencial acima de 4 pavimentos"])
            {
                body["multiRes"] = {"areaUtil": input.areaUtil}
            }
            if (input.tipoImovel === tipoImovelSiglasLegado["Condomínio de lotes"] | input.tipoImovel === tipoImovelSiglasLegado["Condomínio de lotes comercial"])
            {
                body["condLotes"] = {"areaTerreno": input.areaTerreno, "temComercio": input.temComercio}
            }
            if (input.tipoImovel === tipoImovelSiglasLegado["ERB"])
            {
                body["erb"] = {"numEstacoes": input.numEstacoes}
            }
            if (input.tipoImovel === tipoImovelSiglasLegado["GLP"])
            {
                body["glp"] = {"areaPlataforma": input.areaPlataforma}
            }
            body["loteamento"] = {"areaTerreno": input.areaTerreno}
            body["taxaOcupMenor30"] = input.taxaOcupMenor30
            body["valorPagoAlvara"] = input.valorAlvara
            body["areaAcrescida"] = input.areaAcrescida
            body["novaTaxaOcupMaior30"] = input.novaTaxaOcupMaior30

            return body
        }
        default: return null
    }


}